import { Grid, TextField, Typography } from '@mui/material';
import { CardComponent } from 'utils/components/card/CardComponent';
import { sanitizeInput } from 'utils/helpers/sanitizeInput/sanitizeInput';

export const LegalRepresentativeForm = ({ register, errors, taxDataValidations, setValue }) => {
  return (
    <CardComponent title='Representante legal' minWidth='100%'>
      <Grid container spacing={2} sx={{ width: '100%' }} mt={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Télefono
          </Typography>
          <TextField
            fullWidth
            placeholder='Número telefónico'
            {...register('legalRepPhone', taxDataValidations.legalRepPhone)}
            error={Boolean(errors.legalRepPhone)}
            helperText={errors.legalRepPhone?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'digits');
              setValue('legalRepPhone', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Correo electrónico
          </Typography>

          <TextField
            fullWidth
            placeholder='correo@empresa.com'
            {...register('legalRepEmail', taxDataValidations.legalRepEmail)}
            error={Boolean(errors.legalRepEmail)}
            helperText={errors.legalRepEmail?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'email');
              setValue('legalRepEmail', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
      </Grid>
    </CardComponent>
  );
};
